"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TierUpgradeModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var TierUpgradeModal = /** @class */ (function (_super) {
    __extends(TierUpgradeModal, _super);
    function TierUpgradeModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleCloseClick = function () {
            _this.props.onClose();
        };
        return _this;
    }
    TierUpgradeModal.prototype.render = function () {
        var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.handleCloseClick });
        return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "info-modal tier-upgrade-modal", isOpen: this.props.showModal, toggle: this.handleCloseClick, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { toggle: this.handleCloseClick, close: closeBtn, children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [(0, jsx_runtime_1.jsx)("img", { className: "d-block mr-3 mb-1 info-icon-selected", src: "/img/Flow-info-selected.svg", alt: "info-icon" }), (0, jsx_runtime_1.jsx)("div", { className: "text-blue-2", children: this.props.title })] }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalBody, { className: "pt-0 overflow-auto", children: (0, jsx_runtime_1.jsxs)("div", { children: [this.props.explanation, (0, jsx_runtime_1.jsx)("p", { className: "font-weight-semi-bold", children: this.props.query })] }) }), (0, jsx_runtime_1.jsxs)(reactstrap_1.ModalFooter, { className: "justify-content-between width-100", children: [this.props.tierUpgradeButtons.map(function (button) { return ((0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary btn-add ".concat(button.hide && "d-none"), onClick: button.onClick, children: button.buttonText }, button.key)); }), (0, jsx_runtime_1.jsx)("button", { className: "btn btn-back", onClick: this.handleCloseClick, children: "No, thanks" })] })] }));
    };
    return TierUpgradeModal;
}(React.Component));
exports.TierUpgradeModal = TierUpgradeModal;
//# sourceMappingURL=TierUpgradeModal.js.map